import { Component, inject, input, OnInit, output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CustomFieldInputComponent } from 'src/app/components/custom-field-input/custom-field-input.component';
import { CustomFieldsConstants } from 'src/app/constants/CustomFieldsConstants';
import { CustomFieldDTO } from 'src/app/DTO/CustomFieldDTO';

@Component({
  selector: 'app-holder-form',
  standalone: true,
  imports: [
    CustomFieldInputComponent,
    ReactiveFormsModule
  ],
  templateUrl: './holder-form.component.html',
  styleUrl: './holder-form.component.scss'
})
export class HolderFormComponent implements OnInit {
  public customFields = input<CustomFieldDTO[]>([]);
  public onStepValid = output<{ customFields: CustomFieldDTO[], formValid: boolean }>();

  private formBuilder = inject(FormBuilder);

  public form: FormGroup = this.formBuilder.group({});
  public fieldTypes = CustomFieldsConstants.InputTypes

  ngOnInit(): void {
    for (const customField of this.customFields()) {
      this.form.addControl(
        customField.id.toString(),
        this.formBuilder.control('')
      );
    }

    this.form.valueChanges.subscribe(() => {
      this.onStepValid.emit({ customFields: this.customFields(), formValid: this.form.valid });
    })
  }
}
